import { Card, Grid, Stack, Typography } from "@compass/core";
import { Select } from "components";
import {
  SurveyExportResource
} from "generated/openApi";
import { useNavigate } from "react-router-dom";

type SurveyExportBodyProps = {
  surveyId: number | undefined;
  exportTypeId: number | undefined;
  setSurveyId: (value: number) => void;
  setExportTypeId: (value: number) => void;
  viewResource: SurveyExportResource;
};

export const SurveyExportBody = ({ surveyId, exportTypeId, setSurveyId, setExportTypeId, viewResource }: SurveyExportBodyProps) => {
  const navigate = useNavigate();

  return (
    <Grid container spacing="lg">
      <Grid item xs={12}>
        <Card>
          <Stack display="flex" direction={"column"} spacing="md">
            <Typography>Exports</Typography>
            <Select
              label="Form"
              value={viewResource?.surveys?.find((x) => x.id === surveyId)}
              options={viewResource?.surveys}
              getOptionLabel={(option) => option.name}
              onChange={(e, value) => {
                setSurveyId(value.id)
              }}
            />
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
};
